import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import './dashboard.styles.scss'
import Worker from './worker'
import Dialog from '../../components/dialog/dialog.component'
import Loading from '../../components/loading/loading.component'

class DashboardPage extends React.Component {

    constructor() {
        super()
        this.worker = Worker(this)
        this.state = this.worker.getDefaultState() 
    }

    componentDidMount(){
        //this.worker.loadMetrics()
    }

    render() {
        return (
            <div className="dashboard">
                {
                    this.state.loading && <Dialog><Loading /></Dialog>
                }
                <div className="cards">
                    
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
}

export default connect(mapStateToProps)(withRouter(DashboardPage))
